import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMenuStorageReturn = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .4,
		d: "M16.19 2H7.82C4.17 2 2 4.17 2 7.81V16.18C2 19.82 4.17 21.99 7.81 21.99H16.18C19.82 21.99 21.99 19.82 21.99 16.18V7.81C22 4.17 19.83 2 16.19 2Z",
		fill: "#FFFFFF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.9199 8.48006H8.76994L9.09994 8.15006C9.38994 7.86006 9.38994 7.38006 9.09994 7.09006C8.80994 6.80006 8.32994 6.80006 8.03994 7.09006L6.46994 8.66006C6.17994 8.95006 6.17994 9.43006 6.46994 9.72006L8.03994 11.2901C8.18994 11.4401 8.37994 11.5101 8.56994 11.5101C8.75994 11.5101 8.94994 11.4401 9.09994 11.2901C9.38994 11.0001 9.38994 10.5201 9.09994 10.2301L8.83994 9.97006H13.9199C15.1999 9.97006 16.2499 11.0101 16.2499 12.3001C16.2499 13.5901 15.2099 14.6301 13.9199 14.6301H8.99994C8.58994 14.6301 8.24994 14.9701 8.24994 15.3801C8.24994 15.7901 8.58994 16.1301 8.99994 16.1301H13.9199C16.0299 16.1301 17.7499 14.4101 17.7499 12.3001C17.7499 10.1901 16.0299 8.48006 13.9199 8.48006Z",
		fill: "#FFFFFF"
	})]
});
export default SvgMenuStorageReturn;
